import Logger from "../../common/utils/Logger";
import Toast from "react-native-toast-message";
import { Share, Alert } from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import colors from "../../config/colors";
import moment from "moment-timezone";
import Base64 from "Base64";

export const showToast = (title, message, type = "success") => {
  Toast.show({
    type: type,
    text1: title,
    text2: message,
  });
};

export const generateKey = (id) => {
  return `${id.toString()}-${Date.now()}`;
  // return `${id.toString()}`;
};

export const showOkDialog = (title, message, onPress) => {
  Alert.alert(title, message, [
    {
      text: "Ok",
      onPress: () => {
        if (onPress) {
          onPress();
        }
      },
    },
  ]);
};

export const sleep = (time) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve({ ok: true });
    }, time);
  });
};

export const parseBoolean = (value) => {
  if (value) {
    if (value == "true") {
      return true;
    }
  }

  return false;
};

export const parseDisplayDate = (dateString, format = null) => {
  return moment
    .utc(dateString)
    .local()
    .format(format || "lll");
};

export const parseSimpleDisplayDate = (dateString) => {
  return moment.utc(dateString).local().format("YYYY-MM-DD");
};

export const parseDecimalPlaces = (number, decimalPlaces = 2) => {
  if (number && number != "0") {
    return Number(number).toFixed(decimalPlaces);
  }
  return number;
};

export const asyncStorageSetItem = async (key, value) => {
  try {
    return await AsyncStorage.setItem(key, value);
  } catch (e) {
    Logger("Unable to save the value to async storage", e);
  }
};

export const asyncStorageGetItem = async (key) => {
  try {
    return await AsyncStorage.getItem(key);
  } catch (e) {
    Logger("Unable to retrieve the item from async storage", e);
  }
};

export const asyncStorageSetData = async (key, value) => {
  try {
    const jsonValue = JSON.stringify(value);
    return await AsyncStorage.setItem(key, jsonValue);
  } catch (e) {
    Logger("Unable to save the value to async storage", e);
  }
};

export const asyncStorageGetData = async (key) => {
  try {
    return await AsyncStorage.getItem(key);
  } catch (e) {
    Logger("Unable to retrieve the stored data", e);
  }
};

export const validateEmail = (email) => {
  return (
    email &&
    email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
  );
};

export const parseAccountAlias = (alias) => {
  if (alias?.includes(":")) {
    return alias?.split(":")[1];
  }
  return alias;
};

export const parseAccountType = (group) => {
  /**
   * 2 = Duo
   * 6 = Duo Canada
   * 8 = Expired
   * 25 = vDuo
   * 30 = Basic
   * 31 = VIP
   * 40 = PBX
   * 42 = Wholesale
   */

  if (
    group == 2 ||
    group == 6 ||
    group == 8 ||
    group == 25 ||
    group == 30 ||
    group == 31
  ) {
    return "residential";
  } else if (group == 40) {
    return "business";
  } else if (group == 42) {
    return "wholesale";
  }

  return "unknown";
};

export const parseUrlParam = (param) => {
  try {
    let prev = param;
    let decoded = decodeURIComponent(prev);

    while (decoded !== prev) {
      prev = decoded;
      decoded = decodeURIComponent(prev);
    }

    return Base64.atob(decoded);
  } catch (e) {
    return param;
  }
};
